import { useState } from 'react';
import axios from 'axios';

const emptyForm = { name: '', email: '', phone: '', message: '' };
const fieldMessages = { name: 'Informe um nome com 2 a 100 caracteres.', email: 'Informe um e-mail válido.', phone: 'Informe um telefone com DDD e 10 ou 11 dígitos.', message: 'Escreva uma mensagem com 10 a 1000 caracteres.' };

export const useContactForm = () => {
  const [values, setValues] = useState(emptyForm);
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState('idle');
  const [feedback, setFeedback] = useState('');
  const onChange = ({ target: { name, value } }) => {
    setValues(previous => ({ ...previous, [name]: value }));
    setErrors(previous => ({ ...previous, [name]: '' }));
    if (status !== 'loading') { setStatus('idle'); setFeedback(''); }
  };
  const onSubmit = async event => {
    event.preventDefault();
    if (status === 'loading') return;
    const payload = Object.fromEntries(Object.entries(values).map(([key, value]) => [key, value.trim()]));
    const invalid = {};
    if (payload.name.length < 2 || payload.name.length > 100) invalid.name = fieldMessages.name;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.email)) invalid.email = fieldMessages.email;
    if (!/^\d{10,11}$/.test(payload.phone.replace(/\D/g, '')) || payload.phone.length > 20) invalid.phone = fieldMessages.phone;
    if (payload.message.length < 10 || payload.message.length > 1000) invalid.message = fieldMessages.message;
    setErrors(invalid);
    if (Object.keys(invalid).length) {
      setStatus('error'); setFeedback('Revise os campos destacados antes de enviar.');
      document.getElementById(`contact-${Object.keys(invalid)[0]}`)?.focus();
      return;
    }
    setStatus('loading'); setFeedback('');
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/contact`, payload, { timeout: 20000 });
      if (data.success !== true) throw new Error('Resposta de envio inválida');
      setStatus('success');
      setFeedback(data.message || 'Mensagem enviada com sucesso! Entraremos em contato em breve.');
      setValues(emptyForm);
    } catch (error) {
      setStatus('error');
      const detail = error.response?.data?.detail;
      if (Array.isArray(detail)) {
        const serverErrors = {};
        detail.forEach(item => { const field = item.loc?.[item.loc.length - 1]; if (fieldMessages[field]) serverErrors[field] = fieldMessages[field]; });
        setErrors(serverErrors); setFeedback('Revise os dados informados e tente novamente.');
        document.getElementById(`contact-${Object.keys(serverErrors)[0]}`)?.focus();
      } else {
        setFeedback(detail?.message || error.response?.data?.message || (error.response ? 'Não foi possível enviar. Tente novamente ou fale conosco pelo WhatsApp.' : 'Não foi possível confirmar o envio. Verifique sua conexão ou fale conosco pelo WhatsApp.'));
      }
    }
  };
  return { values, errors, status, feedback, onChange, onSubmit };
};